
import { Group, Line } from 'react-konva';
import { KONVA_FACET_GROUP } from '../../../../constants';
import { KonvaGroupNames } from '../../utils';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import useRoofLines from '../useRoofLines';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { selectAllEdges } from 'store/slices/RoofDataSlice/roofSelector';

export default function SpecialEdges() {
	const roofLines = useRoofLines();
	const allRoofEdges = useSelector(selectAllEdges);
	const { deletedRoofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { enableEditFacet } = useSelector((state: RootState) => state.roofEditData.data);
	const { activeRoofTool } = useSelector((state: RootState) => state.roofToolLines.data);
	const { showAutoDetectedEdges } = useSelector((state: RootState) => state.roofData.data);
	
	const scale = useKonvaImageScale();

	return (
		<Group
			visible= {!enableEditFacet && !activeRoofTool}
			scale={scale}
			name={`special-edges-${KONVA_FACET_GROUP.GROUP_NAME_SEPARATOR}${KONVA_FACET_GROUP.EXISTING_GROUP_NAME}`}
			listening={false}
		>
			{allRoofEdges.map((edge) => {
				if (!edge.specialEdge || 
					deletedRoofIndexes.includes(edge.roofSegmentId) ||
					(!showAutoDetectedEdges && edge.specialEdge.isSystemDetected)
				) {
					return null;
				}
				return(
					<Line
						key={edge.id}
						name={`${KonvaGroupNames.existingFacetsGroup}${KONVA_FACET_GROUP.GROUP_NAME_SEPARATOR}gutter-line`}
						id={`${edge.id}`}
						closed={true}
						strokeScaleEnabled={false}
						strokeWidth={3}
						points={edge.coords.flat()}
						draggable={false}
						stroke={roofLines[edge.specialEdge.type].color || '#003cff'}
						listening={false}
						dash={roofLines[edge.specialEdge.type].dashed}
					/>
				);
			})}
		</Group>
	);
}
